import 'css-chunksrc/client/scenes/optimizedGantt/header/filters/styles.scss';export default {
  "filters": "_filters_n8t87_1",
  "resetButton": "_resetButton_n8t87_9",
  "label": "_label_n8t87_17",
  "section": "_section_n8t87_23"
};